import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

class ErrorPage extends Component {


    render() {
        //TODO extend to support multiple types of errors
        return (<span>You do not have an account in the system. Please contact your instructor if you believe this is an error.</span>);
    }
}

ErrorPage.propTypes = {
    dispatch: PropTypes.func.isRequired,
    pageState: PropTypes.object.isRequired,
    router: PropTypes.object.isRequired
};

function mapStateToProps(state) {

    return {
        pageState: state
    };
}

export default connect(

    mapStateToProps
)(
    withRouter(ErrorPage)
);




/** WEBPACK FOOTER **
 ** ./src/components/ErrorPage.js
 **/